import api from "./axios";
import { TagApiItem, TagsResponse } from "@/types/tags";

export async function fetchTags() {
  const res = await api.get<TagsResponse<TagApiItem[]>>("/tags");

  const tags = res.data.data.map((tag) => ({
    id: tag.id,
    translations: tag.translations,
    blogsCount: tag.blogs_count,
  }));

  return {
    tags: tags,
    totalBlogsCount: res.data.total_blogs_count,
  };
}
